import * as React from 'react';
import { useParams } from 'react-router-dom';

import type { RouteParam } from '@/types';

import { useFeatureConfigUI } from './query/useFeatureConfig';
import { useFetchPublicApps } from './query/useFetchPublicApps';
import { useResponsiveConstants } from './responsive/useResponsiveConstants';
import { useIsSharedFeed } from './useIsSharedFeed';
import { useQueryParams } from './useQueryParams';

export const useShowDelete = () => {
  const { category, source, subCategory } = useParams<RouteParam>();
  const { data: publicData, isLoading: isPublicLoading } = useFetchPublicApps();
  const { mobile } = useResponsiveConstants();
  const [query] = useQueryParams();
  const { isSharedData } = useIsSharedFeed();
  const { feature } = useFeatureConfigUI('doc_delete');

  const shouldShowDelete = React.useMemo(() => {
    const isTagsFeed = source === 'tags' || source === 'bookmarks';
    const isRssAndWebsites = subCategory === 'rss_news';
    const isExchanges = subCategory === 'exchanges';
    const isPublicSourcesFeed =
      !isPublicLoading &&
      category === 'apps' &&
      publicData?.some((obj) => obj.key === source);

    if (
      isSharedData ||
      isPublicSourcesFeed ||
      isTagsFeed ||
      isRssAndWebsites ||
      isExchanges ||
      mobile ||
      query.search_type === 'needl_web' ||
      !feature
    ) {
      return false;
    }
    return true;
  }, [
    category,
    isPublicLoading,
    isSharedData,
    mobile,
    publicData,
    query.search_type,
    source,
    subCategory,
    feature,
  ]);

  return { shouldShowDelete };
};
